<template>
  <v-img
    :src="pcsLogoUrl"
    :height="height || null"
    :width="width || null"
    :max-height="height ? null : (smallSize ? 72 : 300)"
    :max-width="width ? null : (height ? height * aspectRatio : (smallSize ? 65 : 400))"
    contain
  />
</template>

<script>
export default {
  props: {
    smallSize: { type: Boolean, default: false },
    height: { type: [Number, String], default: null },
    width: { type: [Number, String], default: null },
    aspectRatio: { type: Number, default: 2 } 
  },
  data() {
    return {
      pcsLogoUrl: require("../../assets/pcs/pcs-logo-200x100.png")
    };
  }
};
</script>
